import Vue from "vue";
import IdleVue from "idle-vue";
import store from "./store";

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 1000 * 60 * 10, //10분 (app.$config.SESSION_TIME)
  startAtIdle: false,
});
